module.exports = __webpack_public_path__ + "static/media/lockIcon.05ded7b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lockIcon.svg
// module id = 652
// module chunks = 0